module.exports = __webpack_public_path__ + "08_face.17490210.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer1/08_face.png
// module id = wU0S
// module chunks = 0